import React from "react"
import PropTypes from "prop-types"
import './SingleImageUpload.css'
import axios from 'axios'
import loading from './loading.gif'
import {s3new} from "../../api";
import ImagePreview from '../ImagePreview'
import SimpleInfoModal from '../../SimpleInfoModal'
import {RFMultiImageUpload} from "../MultiImageUpload";


class RFSingleImageUpload extends React.Component {
  static LOADING = 'loading'
  static WAIT_FOR_FILE = 'wait_for_file'
  static SHOW_INFO_MODAL = 'show_info_modal'

  constructor(props) {
    super(props)
    this.state = {
      act: RFSingleImageUpload.WAIT_FOR_FILE,
      infoModalContent: ''
    }
  }

  render () {
    const {input: {value}} = this.props
    let image = ''
    if (this.state.act !== RFSingleImageUpload.LOADING) {
      image = value
    } else {
      image = loading
    }
    return (
        <div className='fields-single-image-upload__wrapper'>
          <ImagePreview
              onDrop={this._onDrop}
              onClickDelete={this._onClickDelete}
              editable={true}
              deletable={!!value}
              image={image}
              addLabel={this.props.addLabel}
              editLabel={this.props.editLabel}
              dropzoneDisablePreview={false}
          />
          <SimpleInfoModal
              show={this.state.act === RFSingleImageUpload.SHOW_INFO_MODAL}
              content={this.state.infoModalContent}
              onClickConfirm={()=>{this.setState({act: RFSingleImageUpload.WAIT_FOR_FILE})}}
          />
        </div>
    );
  }

  _onClickDelete = () => {
    const {input: {onChange}} = this.props
    onChange('')
  }

  _onDrop = async (acceptedFiles) => {
    const {input: {onChange}} = this.props
    let validateResolutionMessage

    if (validateResolutionMessage = await this._invalidImage(acceptedFiles[0].preview, acceptedFiles[0].type, acceptedFiles[0].size)) {
      this.setState({
        act: RFMultiImageUpload.SHOW_INFO_MODAL,
        infoModalContent: validateResolutionMessage
      })
    } else {
      this.setState({
        act: RFSingleImageUpload.LOADING
      })
      this.uploadImage(acceptedFiles[0]).then((url) => {
        onChange(url)
        this.setState({
          act: RFSingleImageUpload.WAIT_FOR_FILE
        })

      }).catch((error) => {
        this.setState({
          act: RFSingleImageUpload.WAIT_FOR_FILE
        })
      })
    }

  }

  uploadImage = async (file) => {
    let resUploadImage = await s3new({})
    const {data} = resUploadImage.data
    let formData = new FormData()
    formData.append('key', data.key)
    formData.append('acl', data.acl)
    formData.append('AWSAccessKeyId', data.aws_access_key_id)
    formData.append('success_action_status', data.success_action_status)
    formData.append('Content-Type', data.content_type)
    formData.append('Cache-Control', data.cache_control)
    formData.append('policy', data.policy)
    formData.append('signature', data.signature)
    formData.append('file', file)
    try {
      await axios.post(data.url, formData, {})
      return Promise.resolve(data.fullUrl)
    } catch (error) {
      return Promise.reject(false)
    } finally {
    }
  }

  _invalidImage = (url, type, size) => {
    const {maxSizeUnit, maxSize,validFileTypes,resolutionMaxWidth, resolutionMaxHeight, resolutionExactWidth, resolutionExactHeight,overrideValidationMessage,mustEqualWidthAndHeight} = this.props
    return new Promise((resolve) => {
      let img = new Image();
      let invalidResult = false

      //validation that does not need rendering the image
      if (!this._isValidMaxFileSize(size, maxSize, maxSizeUnit)){
        invalidResult = overrideValidationMessage || `File size limit exceeded`
      } else if (!this._isValidFileTypes(validFileTypes, type)){
        invalidResult = overrideValidationMessage || `Invalid file types`
      }

      if (invalidResult){
        resolve(invalidResult)
      } else {
        //validate with rendering - need callback
        img.onload = () => {
          if (resolutionExactWidth !== null && resolutionExactHeight !== null && (img.width !== resolutionExactWidth || img.height !== resolutionExactHeight)){
            invalidResult = overrideValidationMessage || `Image resolution should be ${resolutionExactWidth}x${resolutionExactHeight} px`
          } else if (resolutionMaxWidth !== null && resolutionMaxHeight !== null && (img.width > resolutionMaxWidth || img.height > resolutionMaxHeight)){
            //validation of max width and height
            invalidResult = overrideValidationMessage ||`Maximum image resolution is ${resolutionMaxWidth}x${resolutionMaxHeight}px`
          } else if (mustEqualWidthAndHeight && img.width !== img.height) { //validate square image
            invalidResult = overrideValidationMessage || `Image resolution must be same`
          }
          resolve(invalidResult)
        }
        img.src = url
      }

    })
  }

  _isValidFileTypes = (validFileTypes, type) => {
    let valid = false
    validFileTypes.forEach((validType) => {
      valid = valid || (type === validType)
    })
    return valid
  }

  _isValidMaxFileSize = (fileSize, maxSize, maxSizeUnit) => {
    let maxSizeByte
    if (maxSizeUnit === 'KB'){
      maxSizeByte = maxSize * 1024
    } else {
      throw new Error('not implemented')
    }
    return fileSize <= maxSizeByte
  }


}

RFSingleImageUpload.propTypes = {
  value: PropTypes.string,
  newName: PropTypes.string,
  maxSize: PropTypes.number,
  maxSizeUnit: PropTypes.string,
  hasNewValue: PropTypes.bool,
  editLabel: PropTypes.string,
  addLabel: PropTypes.string,
  //specify this AND height if need validation of resolution
  resolutionExactWidth: PropTypes.number,
  //specify this AND width if need validation of resolution
  resolutionExactHeight: PropTypes.number,
  resolutionMaxWidth: PropTypes.number,
  resolutionMaxHeight: PropTypes.number,
  //specify this if we want to validate the width === height
  mustEqualWidthAndHeight: PropTypes.bool,
  overrideValidationMessage: PropTypes.oneOfType([PropTypes.string,PropTypes.node]),
  validFileTypes: PropTypes.array
}

RFSingleImageUpload.defaultProps = {
  maxSizeByte: 256,
  maxSize: 'KB',
  resolutionExactWidth: null,
  resolutionExactHeight: null,
  resolutionMaxWidth: null,
  resolutionMaxHeight: null,
  mustEqualWidthAndHeight: false,
  overrideValidationMessage: null,
  validImageTypes: []
}

export {RFSingleImageUpload}



// WEBPACK FOOTER //
// app/javascript/components/fields/SingleImageUpload/SingleImageUpload.js